<mat-dialog-content>
  <h1 class="text-black text-2xl mb-4">Agregar Usuario</h1>
  <form [formGroup]="userForm" (ngSubmit)="handleCreateUser()">
    <div class="flex flex-col">
      <label for="email" class="text-gray-700">Email</label>
      <input id="email" matInput type="text" formControlName="email" placeholder="Ingrese su email"
        class="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:border-blue-500">
      <mat-error *ngIf="userForm.get('email')?.hasError('required') && userForm.get('email')?.touched">El email es
        requerido</mat-error>
    </div>
    <div class="flex flex-col">
      <label for="password" class="text-gray-700">Contraseña</label>
      <input id="password" matInput type="password" formControlName="password" placeholder="Ingrese su contraseña"
        class="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:border-blue-500">
      <mat-error *ngIf="userForm.get('password')?.hasError('required') && userForm.get('password')?.touched">La
        contraseña es requerida</mat-error>
    </div>
    <div class="flex flex-col">
      <label for="role" class="text-gray-700">Rol</label>
      <select id="role" formControlName="role" matNativeControl
        class="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:border-blue-500">
        <option value="">Seleccione un rol</option>
        <option value="ROLE_ADMIN">ROLE_ADMIN</option>
        <option value="ROLE_CRM">ROLE_CRM</option>
        <option value="ROLE_CONSULTANT">ROLE_CONSULTANT</option>
      </select>
      <mat-error *ngIf="userForm.get('role')?.hasError('required') && userForm.get('role')?.touched">El rol es
        requerido</mat-error>
    </div>
  </form>
</mat-dialog-content>


<mat-dialog-actions class="justify-between">
  <button class="bg-orange-400 hover:bg-orange-500 text-white font-bold py-2 px-4 mb-3 rounded" mat-button type="submit"
    [disabled]="!userForm.valid" (click)="handleCreateUser()">Agregar Usuario</button>
  <button class="bg-red-400 hover:bg-red-500 text-white font-bold py-2 px-4 mb-3 ml-5 rounded" mat-button
    (click)="closeModal()">Cancelar</button>
</mat-dialog-actions>
